// Ported from workspace-services as a temporary solution until UUIDv7 is widely supported.
// To be removed as part of OPTI-3445.
export const convertToUUIDv7 = (uuidV4: string, dt: Date): string => {
  const timestampMs = Math.floor(dt.getTime());
  const timestampHex = timestampMs.toString(16).padStart(12, "0");
  const remainingHex = uuidV4.replace(/-/g, "").substring(12);
  const versionHex = "7" + remainingHex.substring(1, 4);
  const variantHex = "8" + remainingHex.substring(5, 8);
  const uuidV7Hex =
    timestampHex + versionHex + variantHex + remainingHex.substring(8);

  // Format as standard UUID with hyphens
  return [
    uuidV7Hex.substring(0, 8),
    uuidV7Hex.substring(8, 12),
    uuidV7Hex.substring(12, 16),
    uuidV7Hex.substring(16, 20),
    uuidV7Hex.substring(20, 32),
  ].join("-");
};

export const getUUIDVersion = (uuid: string): number => {
  const versionNibble = uuid.replace(/-/g, "").charAt(12);

  return parseInt(versionNibble, 16);
};
